module.exports = __webpack_public_path__ + "img/girl.b52cb190.png";